import * as THREE from 'three'
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader.js'
import Experience from '../Experience.js'

export default class Resources
{
    constructor(pSources)
    {
        // Event Bus instance
        this.eventDispatcher = new THREE.EventDispatcher();

        // Options / references to file sources
        this.sources = pSources;

        //console.log(this.sources);
        this.objectsLoaded = {};
        this.materialsLoaded = {};
        this.toLoad = this.sources.length;
        this.loaded = 0;

        this.experienceRef = new Experience();
        this.rendererRef = this.experienceRef.renderer;

        this.setLoaders();
        this.startLoading();
    }

    on(event, callback) 
    {
        this.eventDispatcher.addEventListener(event, callback);
    }

    setLoaders()
    {
        this.loaders = {};
        this.loaders.gltfLoader = new GLTFLoader();
        this.loaders.textureLoader = new THREE.TextureLoader();
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader();
        this.loaders.dracoLoader = new DRACOLoader
        this.loaders.dracoLoader.setDecoderPath('/draco/')        
        this.loaders.gltfLoader.setDRACOLoader(this.loaders.dracoLoader)
        this.loaders.audioLoader = new THREE.AudioLoader();

        this.loaders.KTX2TextureLoader = new KTX2Loader()
        this.loaders.KTX2TextureLoader.setTranscoderPath('/basis/')        
        this.loaders.KTX2TextureLoader.detectSupport(this.rendererRef.webGLrendererInstance)
    }
    
    startLoading()
    {
        // Load each source
        for (const source of this.sources)
        {
            if (source.type == 'dracoGltfModel')
            {
                this.loaders.gltfLoader.load(
                    source.path,
                    (file) => 
                    {
                        //console.log(source, file);
                        this.sourceLoaded(source, file);
                    }
                );
            }
            else if (source.type == 'gltfModel')
            {
                this.loaders.gltfLoader.load(
                    source.path,
                    (file) => 
                    {
                        //console.log(source, file);
                        this.sourceLoaded(source, file);
                    }
                );
            }
            else if (source.type == 'texture')
            {
                this.loaders.textureLoader.load(
                    source.path,
                    (file) => 
                    {
                        //console.log(source, file);
                        file.flipY = false
                        file.colorSpace = THREE.SRGBColorSpace;
                        this.sourceLoaded(source, file);
                    }
                );
            }
            else if (source.type == 'cubeTexture')
            {
                this.loaders.cubeTextureLoader.load(
                    source.path,
                    (file) => 
                    {
                        //console.log(source, file);
                        this.sourceLoaded(source, file);
                    }
                );
            }
            else if (source.type == 'audio')
            {
                this.loaders.audioLoader.load(
                    source.path,
                    (file) => 
                    {
                        //console.log(source, file);
                        this.sourceLoaded(source, file);
                    }
                );
            }
            else if(source.type === 'KTX2texture')
            {
                this.loaders.KTX2TextureLoader.load(
                    source.path,
                    (file) =>
                    {
                        //console.log(source, file);
                        file.encoding = THREE.sRGBEncoding
                        this.sourceLoaded(source, file)
                    }
                )
            }
        }
    }

    sourceLoaded(pSource, pFile)
    {        
        this.eventDispatcher.dispatchEvent( { type: 'itemLoaded'} );

        this.objectsLoaded[pSource.name] = pFile;        

        // Load all the mapped materials
        if(pFile.scene)
        {            
            pFile.scene.traverse((child) => {
                // Check if the child has a material and a name assigned from Blender
                if (child.material && child.material.name)
                {
                    // Log the type of material
                    //console.log('Object :', child.parent.name);
                    //console.log('Material :',child.material.name);

                    this.materialsLoaded[child.material.name] = child.material;
                }
            })            
        }

        this.loaded++;
        if(this.loaded === this.toLoad)
        {
            //console.log('All files loaded. Ready to go!');           
            
            setTimeout(() => {
                this.eventDispatcher.dispatchEvent({ type: 'allAssetsLoaded' });
            }, 0); // defer to next tick to avoid Race condition and the subscribers missing the Event
            
        }
    }


}

// gltfLoader.load(
//     '/models/desktopPcCabinet.glb',
//     (gltf) => {
//         console.log("success");
//         //console.log(gltf.scene);
//         // Using while() since adding objects from gltf object removes them from the list/alters the gltf mesh array
//         console.log(gltf.scene);
//         while (gltf.scene.children.length)
//         {            
//             scene.add(gltf.scene.children[0]);
//         }      
        
//         gltf.parser.getDependencies( 'material' ).then( ( materials ) => {

//             console.log( materials );
        
//         } );
//     },
//     (progress) => {
//         console.log("progress");
//         console.log(progress);
//     },
//     (error) => {
//         console.log("error");
//         console.log(error);
//     }
// );